import queryString from "query-string";
import {GET_EMPLOYEE_BY_MANAGER, GENERATE_IDP_EXAMINATION, GET_IDP_EXAMINATION_BY_NIK, EDIT_PROFICIENCY_IDP,GENERATE_IDP_REPORT, EDIT_DATA_IDP_EXAMINATION } from "@/api/idp-examination/idp-examination";

const state = {
    //
    idp: [],
    idpReport:[],
    employeeByManager: [],
    idpExaminationByNik:[],
};
const mutations = {
    setIdp: (states, payload) => {
        states.idp = payload;
    },
    setIdpReport: (states, payload) => {
        states.idpReport = payload;
    },
    setEmployeeByManager: (states, payload) => {
        states.employeeByManager = payload;
    },
    setIdpExaminationByNik: (states, payload) => {
        states.idpExaminationByNik = payload;
    },
    setEditProficiencyIdp: (states, payload) => {
        states.editProficiencyIdp = payload;
    },

};
const actions = {
    getIdpExamination: async ({ commit }, args) => {
        const params = queryString.stringify(args);

        try {
            const resp = await GENERATE_IDP_EXAMINATION(params);
            // console.log("resppp", resp)
            if (resp.data.httpCode === 200) {
                commit("setIdp", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            // console.log(resp)
            if (resp.data.httpCode === 404) {
                commit("setIdp", []);
            }
            throw err;
        }
    },
    getIdpReport: async ({ commit }, args) => {
        const params = queryString.stringify(args);

        try {
            const resp = await GENERATE_IDP_REPORT(params);
            // console.log("resppp", resp)
            if (resp.data.httpCode === 200) {
                commit("setIdpReport", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            // console.log(resp)
            if (resp.data.httpCode === 404) {
                commit("setIdpReport", []);
            }
            throw err;
        }
    },
    getEmployeeByManager: async ({ commit }, args) => {
        try {
            const resp = await GET_EMPLOYEE_BY_MANAGER(args);
            // console.log("resppp", resp)
            if (resp.data.httpCode === 200) {
                commit("setEmployeeByManager", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            // console.log("catch",err)
            if (resp.data.httpCode === 404) {
                commit("setEmployeeByManager", []);
            }
            throw err;
        }
    },
    getIdpExaminationByNik: async ({ commit }, args) => {

        try {
            const resp = await GET_IDP_EXAMINATION_BY_NIK(args);
            // console.log("resppp", resp)
            if (resp.data.httpCode === 200) {
                commit("setIdpExaminationByNik", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            // console.log(resp)
            if (resp.data.httpCode === 404) {
                commit("setIdpExaminationByNik", []);
            }
            throw err;
        }
    },
    editProficiencyIdp: async ({ }, args) => {
        return await EDIT_PROFICIENCY_IDP(args);
    },
    editDataIdpExamination: async ({ }, args) => {
        return await EDIT_DATA_IDP_EXAMINATION(args);
    },
};

const getters = {
    Idp: (states) => states.idp,
    IdpExaminationByNik: (states) => states.idpExaminationByNik,
    EmployeeByManager: (states) => states.employeeByManager,
    EditProficiencyIdp: (states) => states.editProficiencyIdp,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
